<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { ResetPasswordForm } from '~/components/feature/auth'

const { t } = useI18n()
const breadcrumbs = [{ title: t('page.password_reset.breadcrumb'), url: '/password/reset' }]
const router = useRouter()
const { getPathWithLocale } = useLocalizedPath()

// Redirect already authenticated users
const { isLoggedIn, initializeAuth } = useUser()

// Initialize auth first, then check login status
await initializeAuth()

if (isLoggedIn.value) {
  await router.push(getPathWithLocale('/'))
}
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <div class="flex min-h-[600px] items-center justify-center py-8">
        <ResetPasswordForm />
      </div>
    </Container>
  </Main>
</template>
